module.exports = __webpack_public_path__ + "static/media/country-home-entrance.f510f5c4.jpeg";